import Account from './Account';
import Route from './route';

export default {
  RenderProp: Account,
  mainRoute: Route,
};
